export const UPDATE_HEADER = 'header/UPDATE';

export const updateHeader = (payload) => ({
  type: UPDATE_HEADER,
  payload,
});
